module.exports = __webpack_public_path__ + "img/index-section6-friend11_a.a1fc0298.svg";